import { isEmpty } from 'lodash-es';

app.directive('destinationSectionSaveAddress', [
  function () {
    return {
      restrict: 'E',
      templateUrl: require('../../../../../public/themes/shared/multi_checkout/templates.destination-section.save-address.html'),
      scope: {
        address: '=',
        country: '@',
        options: '=',
        disabled: '=',
        userAddresses: '=',
        deliveryOptionIds: '=',
      },
      link: function (scope) {
        scope.state = {
          tempAddress: {},
          addressType: 'saved-address-0',
          defaultAddress: scope.address,
        };

        scope.shouldValidate = () => {
          return (
            scope.state.addressType === 'new' &&
            scope.options.validateBeforeSubmit
          );
        };

        scope.setUserAddress = (userAddress) => {
          scope.address = userAddress;
        };

        scope.$watch('state.addressType', function (newVal, oldVal) {
          if (newVal === oldVal) {
            return;
          }

          if (newVal === 'new') {
            scope.address = scope.state.tempAddress;
            return;
          }

          if (newVal.includes('saved-address-')) {
            scope.options.validateBeforeSubmit = false;
            return;
          }
        });

        scope.$watch('state.defaultAddress', function (newVal) {
          if (isEmpty(newVal)) {
            scope.address = scope.userAddresses[0] || {};
            return;
          }

          const addressString = getFullAddress(newVal);

          const userAddressIndex = scope.userAddresses.findIndex(
            (userAddress) => {
              const userAddressString = getFullAddress(userAddress);
              return addressString === userAddressString;
            },
          );

          if (userAddressIndex > -1) {
            scope.state.addressType = `saved-address-${userAddressIndex}`;
            scope.address = scope.userAddresses[userAddressIndex];
            return;
          }

          scope.state.addressType = 'new';
          scope.state.tempAddress = newVal;
          scope.address = newVal;
        });

        function getFullAddress(addressObject) {
          const { country, city, address_1, address_2 } = addressObject;
          return `${country}.${city}.${address_1}.${address_2}`;
        }
      },
    };
  },
]);
